export default __webpack_public_path__ + "static/media/caricatura.5e14edf1.png";